import styled from 'styled-components'

const PairedOrderPanelContainer = styled.div`
  height: 60px;
  padding: 0 30px;
`

PairedOrderPanelContainer.displayName = 'PairedOrderPanelContainer'
export default PairedOrderPanelContainer
